<ion-content class="theme-{{userService.theme}}">
    <ion-header>
        <app-header [backRoute]="['/home']"
                   ></app-header>
    </ion-header>
<div class="resources-wrap page-width-and-shadow">

    <div class="title content-wrap" [@enter]>
        <span class="my-color-blue">{{'__RESOURCE_TITLE__' | translate}}</span>
        <app-inline-svg class="icon" [file]="'assets/img/footer/box.svg'"></app-inline-svg>
    </div>

    <div class="small content-wrap" [@enter]>{{'__RESOURCE_DESCRIPTION__' | translate}}</div>

    <div class="list content-wrap" *ngIf="this.resourceList !== null">
        <div class="line" *ngFor="let item of resourceList ; let i = index"
             [@leave]>
            <div class="logo"><img src="assets/img/{{item.type}}.svg" alt="video" (click)="openResource(item)"></div>
            <div class="texts" (click)="openResource(item)">
                <div class="my-color-blue">{{item.folder}}</div>
                <div class="text">{{item.title}}</div>
                <div class="small">{{item.description}}</div>
            </div>
            <ion-checkbox class="My-checkbox" (click)="updateStatus(item)"
                          [(ngModel)]="item.status"></ion-checkbox>
        </div>
    </div>

    <app-skeleton-tasks class="content-wrap" *ngIf="this.resourceList === null"></app-skeleton-tasks>
</div>
</ion-content>
